import axios from 'axios';
import customAxios from '../../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../../scss/Components/_modal.scss"
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../../globalVar';
import { getToast } from '../../../../utils/toastConfig';

function ModalSMultDelete(props) {
    let idList = []
    let siteDeleteList = localStorage.getItem("sitesMultipleDeleteList");
    if (siteDeleteList !== null && siteDeleteList !== undefined) {
        idList = siteDeleteList.replace(/\[|\]|\'/g, '').split(',').map(Number);
    }

    const deleteSites = () => {
        customAxios.patch(`${GlobalVariables.getURL()}multipleDeleteSites`, { idList }, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(response => {
            console.log(response.data);
            hideS();
        })
        .catch(error => {
            console.error(error);
            getToast({ status: 'error', title: 'Error al eliminar sucursal(es). Vuelve a intentarlo.' });
        });
    } 
    
    function hideS(){
        props.onHide();
        getToast({ status: 'success', title: 'Sucursal(es) eliminada(s) exitosamente en la base de datos.' });
        let endpoint = `${GlobalVariables.getURL()}listClientSites`;
        if (props.selectedClients.length > 0) {
            endpoint += `?id=${props.selectedClients}`;
        }
        props.getSites(endpoint);
    }

    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    ¿Quieres borrar estas sucursales?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {idList.map(id => <span><strong>ID de la Sucursal:</strong> {id}<br/></span>)}
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteSites()}}><FontAwesomeIcon icon={faWarning}/> Si, quiero eliminar esto.</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> No, regrésame a la tabla.</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalSMultDelete;